import React, { useEffect, useState } from 'react';
import { Rect, Text, Transformer } from 'react-konva';

import DeleteDiagram from './DeleteDiagram';
import EditDiagram from './EditDiagram';

const ResizeRect = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  isEdit,
  arrIndexFloat,
  setNumberKey,
  setShow,
  setEdit,
  setDelete,
  handleDragStart,
  width,
  height,
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  const [idFloat, setIdFloat] = useState();

  useEffect(() => {
    if (isSelected && isEdit) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
    setIdFloat(
      arrIndexFloat?.find((elm) => elm[0].index === shapeRef.current?.attrs.id)
    );
  }, [isSelected, isEdit, arrIndexFloat]);

  function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    context.font = font || getComputedStyle(document.body).font;

    if (text && text?.length > 3) {
      return context.measureText(text).width + 12;
    } else {
      return context.measureText(text).width + 3;
    }
  }

  return (
    <React.Fragment>
      <Rect
        onDragStart={() =>
          handleDragStart(shapeRef.current?.attrs.topLeftPoint.x)
        }
        fillPriority="linear-gradient" // 'color', 'pattern', 'linear-gradient', 'radial-gradient'
        /* linear-gradient */
        fillLinearGradientStartPoint={{ x: 0, y: 0 }}
        fillLinearGradientEndPoint={{ x: 0, y: shapeRef.current?.attrs.height }}
        fillLinearGradientColorStops={
          idFloat
            ? [0, 'white', 0.2, '#2ca961', 1, '#2ca961']
            : [0, 'white', 0.9, 'white', 0.99, 'red', 1, 'red']
        }
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable={isEdit}
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={(e) => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      />
      <Text
        text={shapeRef.current?.attrs.label}
        x={
          shapeRef.current?.attrs.x +
          shapeRef.current?.attrs.width / 2 -
          getTextWidth(shapeRef.current?.attrs.label) / 2
        }
        y={shapeRef.current?.attrs.y + shapeRef.current?.attrs.height / 2}
        fontSize={12}
        fill={idFloat ? 'white' : 'black'}
      />

      {isEdit && (
        <>
          <EditDiagram
            numberKey={shapeRef.current?.attrs.topLeftPoint.x}
            setNumberKey={setNumberKey}
            x={shapeRef.current?.attrs.x + shapeRef.current?.attrs.width - 35}
            y={shapeRef.current?.attrs.y - 20}
            setShow={setShow}
            setEdit={setEdit}
          />
          <DeleteDiagram
            numberKey={shapeRef.current?.attrs.topLeftPoint.x}
            setNumberKey={setNumberKey}
            setShow={setShow}
            setDelete={setDelete}
            x={shapeRef.current?.attrs.x + shapeRef.current?.attrs.width - 20}
            y={shapeRef.current?.attrs.y - 20}
          />
        </>
      )}
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ResizeRect;
